'use strict';

angular.module('selfAccessRequestControllers').controller('ArrivalCompletedController', [
  '$scope',
  '$window',
  '$interval',
  '$state',
  '$stateParams',
  'topBar',
  'requestWithSNOWParams',
  function ($scope, $window, $interval, $state, $stateParams, topBar, requestWithSNOWParams) {
    topBar.setTitleAndIcon('Self Service Arrival Request | Completed', 'fa-pencil-square-o');

    $scope.ctrlCtxt = {};
    $scope.requestWithSNOWParams = requestWithSNOWParams;

    if (requestWithSNOWParams && requestWithSNOWParams.SelfRequestUrlSNOW) {
      // Open SNOW URL in a new tab after 4 seconds
      $interval(
        function () {
          $scope.ctrlCtxt.showRedirectToSnowAction = true;
          window.open(requestWithSNOWParams.SelfRequestUrlSNOW, '_blank');
        },
        4000,
        1
      );
    }
  },
]);
